export default __webpack_public_path__ + "static/media/assessment_glide_2_1.10385f08.svg";